var _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServices1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "services1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.739,
    height: 43.482,
    viewBox: "0 0 68.739 43.482",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_272",
    "data-name": "Group 272",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_271",
    "data-name": "Group 271"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M63.927,112.5l-1.78-7.12A1.076,1.076,0,0,0,63,104.323v-1.148a4.526,4.526,0,0,0-4.52-4.52H50.37V96.286a2.227,2.227,0,0,0-2.224-2.224H6.816a2.227,2.227,0,0,0-2.224,2.224V115.8a1.076,1.076,0,0,0,2.153,0V96.286a.072.072,0,0,1,.072-.072H48.146a.072.072,0,0,1,.072.072V115.8a1.076,1.076,0,1,0,2.153,0v-1.22h12.7a3.522,3.522,0,0,1,3.345,2.44H63.07a1.076,1.076,0,0,0-1.076,1.076v2.3a3.376,3.376,0,0,0,3.372,3.372h1.22V128.5H63.772a6.814,6.814,0,0,0-12.884,0H50.37V120.4a1.076,1.076,0,1,0-2.153,0V128.5H25.887A6.814,6.814,0,0,0,13,128.5H6.816a.072.072,0,0,1-.072-.072v-2.368h4.664a1.076,1.076,0,0,0,0-2.153H1.076a1.076,1.076,0,0,0,0,2.153H4.592v2.368a2.227,2.227,0,0,0,2.224,2.224H12.63c0,.024,0,.048,0,.072a6.816,6.816,0,0,0,13.633,0c0-.024,0-.048,0-.072H50.515c0,.024,0,.048,0,.072a6.816,6.816,0,0,0,13.633,0c0-.024,0-.048,0-.072h3.518a1.076,1.076,0,0,0,1.076-1.076V118.1A5.677,5.677,0,0,0,63.927,112.5ZM50.37,100.807h8.108a2.371,2.371,0,0,1,2.368,2.368v.072H50.37Zm0,11.624V105.4h9.564l1.758,7.032ZM19.445,135.391a4.664,4.664,0,1,1,4.664-4.664A4.669,4.669,0,0,1,19.445,135.391Zm37.885,0a4.664,4.664,0,1,1,4.664-4.664A4.669,4.669,0,0,1,57.33,135.391Zm9.256-13.776h-1.22a1.221,1.221,0,0,1-1.22-1.22v-1.22h2.44v2.44Z",
    transform: "translate(0 -94.062)",
    fill: "#1d2547"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_274",
    "data-name": "Group 274",
    transform: "translate(17.221 34.441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_273",
    "data-name": "Group 273"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M130.491,350.6a2.224,2.224,0,1,0,2.224,2.224A2.227,2.227,0,0,0,130.491,350.6Z",
    transform: "translate(-128.267 -350.597)",
    fill: "#1d2547"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_276",
    "data-name": "Group 276",
    transform: "translate(55.106 34.441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_275",
    "data-name": "Group 275"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M412.679,350.6a2.224,2.224,0,1,0,2.224,2.224A2.227,2.227,0,0,0,412.679,350.6Z",
    transform: "translate(-410.455 -350.597)",
    fill: "#1d2547"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_278",
    "data-name": "Group 278",
    transform: "translate(27.553 29.849)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_277",
    "data-name": "Group 277"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M222.376,316.393H206.3a1.076,1.076,0,1,0,0,2.153h16.072a1.076,1.076,0,1,0,0-2.153Z",
    transform: "translate(-205.227 -316.393)",
    fill: "#1d2547"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_280",
    "data-name": "Group 280",
    transform: "translate(2.296 25.257)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_279",
    "data-name": "Group 279"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M31.955,282.188H18.178a1.076,1.076,0,1,0,0,2.153H31.955a1.076,1.076,0,1,0,0-2.153Z",
    transform: "translate(-17.102 -282.188)",
    fill: "#1d2547"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_282",
    "data-name": "Group 282",
    transform: "translate(19.517 10.332)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_281",
    "data-name": "Group 281"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M163.28,171.338a1.076,1.076,0,0,0-1.522,0l-9.571,9.571-4.979-4.979a1.076,1.076,0,0,0-1.522,1.522l5.74,5.74a1.076,1.076,0,0,0,1.522,0l10.332-10.332A1.076,1.076,0,0,0,163.28,171.338Z",
    transform: "translate(-145.37 -171.023)",
    fill: "#1d2547"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices1);
export default __webpack_public_path__ + "static/media/services1.43b00590a7668d621bab1bc171f0e85b.svg";
export { ForwardRef as ReactComponent };